module.exports = __webpack_public_path__ + "media/images/index/product_line/accident-4443e1c6fa8574f59ee025fe75133088.svg";